
import { mapActions, mapGetters } from "vuex";
import DisintergrationReasonDialogContent from "../dialogs/disintergration-reason-dialog-content.vue";
import DisintergrationReasonDialog from "../dialogs/disintergration-reason-dialog.vue";
import ChannelManagerFormBrandSection from "./channel-manager-form-brand-section.vue";

export default {
  props: {
    isPairedChannelTab: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    whatsappInfo: {
      type: Map,
      default: new Map()
    },
    channelsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newChannel: "",
      pairedUnpairedTab: 0,
      isFormValid: false
    };
  },
  components: {
    DisintergrationReasonDialogContent,
    DisintergrationReasonDialog,
    ChannelManagerFormBrandSection
  },
  computed: {
    ...mapGetters("restaurant", [
      "getUnpairedChannelsList",
      "getLocationChannels",
      "getAllBrands",
      "hasMultipleBrands"
    ]),
    selectedChannelCount() {
      let count = 0;
      this.channelsList.forEach((restaurant) => {
        let chosenChannels = restaurant.restaurant_platforms.filter((channel) =>
          this.isPairedChannelTab ? channel.isSelected : !!channel.userInput
        );
        count += chosenChannels.length;
      });
      return count;
    }
  },
  watch: {
    channelsList: {
      handler() {
        this.validateForm();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("restaurant", ["integrateChannels", "disintegrateChannels"]),
    validateForm() {
      this.isFormValid = false;
      this.channelsList.forEach((restaurant) => {
        let chosenChannels = restaurant.restaurant_platforms.filter((channel) =>
          this.isPairedChannelTab ? channel.isSelected : !!channel.userInput
        );
        if (chosenChannels.length) {
          this.isFormValid = true;
        }
      });
    },
    handlePairChannel(e, channelIndex, brandIndex) {
      if (this.isPairedChannelTab) {
        this.$emit("disintegration-selection", e, channelIndex, brandIndex);
      } else {
        this.$emit("integration-selection", e, channelIndex, brandIndex);
      }
    },

    handleProceedButtonClick() {
      if (this.isPairedChannelTab) {
        this.$emit("proceed-disintegration");
      } else {
        this.$emit("proceed-integration");
      }
    }
  }
};
